export interface TestimonialData {
  id: string;
  text: string;
  author: string;
  position?: string;
  company?: string;
}

export const TESTIMONIALS_DATA: TestimonialData[] = [
  {
    id: "1",
    text: "Working with Soloop has been transformative for our business. Their team took the time to understand our unique challenges and delivered a solution that exceeded our expectations. Their technical expertise combined with their collaborative approach made the entire development process smooth and efficient.",
    author: "Sarah Johnson",
    position: "CEO",
    company: "TechCorp"
  },
  {
    id: "2",
    text: "Soloop's innovative approach to software development has revolutionized how we operate. Their attention to detail and commitment to quality is unmatched. The final product not only met but exceeded all our requirements.",
    author: "Michael Chen",
    position: "CTO",
    company: "InnovateTech"
  },
  {
    id: "3",
    text: "The team at Soloop is exceptional. They delivered our project on time and within budget, while maintaining the highest standards of quality. Their communication throughout the process was excellent.",
    author: "Emily Rodriguez",
    position: "Product Manager",
    company: "StartupXYZ"
  },
  {
    id: "4",
    text: "Soloop's expertise in modern technologies and their ability to scale solutions has been crucial for our growth. They truly understand the business side of technology.",
    author: "David Thompson",
    position: "Founder",
    company: "ScaleUp Inc"
  },
  {
    id: "5",
    text: "Outstanding service and technical excellence. Soloop transformed our vision into reality with precision and creativity. Their post-launch support has been invaluable.",
    author: "Lisa Wang",
    position: "Director of Operations",
    company: "Global Solutions"
  },
  {
    id: "6",
    text: "Soloop's team demonstrated exceptional problem-solving skills and technical knowledge. They delivered a robust solution that perfectly fits our business needs.",
    author: "James Wilson",
    position: "IT Director",
    company: "Enterprise Corp"
  },
  {
    id: "7",
    text: "Working with Soloop was a game-changer for our company. Their innovative solutions and professional approach exceeded all expectations.",
    author: "Maria Garcia",
    position: "CEO",
    company: "Digital Ventures"
  },
  {
    id: "8",
    text: "Soloop's commitment to quality and their technical expertise made our project a huge success. They are truly partners in our business growth.",
    author: "Robert Kim",
    position: "VP of Technology",
    company: "FutureTech"
  },
  {
    id: "9",
    text: "The level of professionalism and technical skill at Soloop is outstanding. They delivered exactly what we needed and more.",
    author: "Jennifer Lee",
    position: "Product Director",
    company: "Innovation Labs"
  },
  {
    id: "10",
    text: "Soloop's team is incredibly talented and dedicated. They turned our complex requirements into a beautiful, functional solution.",
    author: "Alex Turner",
    position: "Founder",
    company: "Creative Solutions"
  },
  {
    id: "11",
    text: "Exceptional work ethic and technical capabilities. Soloop delivered a solution that perfectly aligns with our business objectives.",
    author: "Sophie Brown",
    position: "Operations Manager",
    company: "Growth Partners"
  },
  {
    id: "12",
    text: "Soloop's innovative approach and attention to detail resulted in a product that exceeded our wildest expectations.",
    author: "Daniel Martinez",
    position: "CTO",
    company: "Tech Innovations"
  },
  {
    id: "13",
    text: "Working with Soloop has been an absolute pleasure. Their expertise and dedication to quality are unmatched in the industry.",
    author: "Rachel Green",
    position: "VP of Product",
    company: "Digital Solutions"
  },
  {
    id: "14",
    text: "Soloop's technical excellence and business understanding made our project a resounding success. Highly recommended!",
    author: "Thomas Anderson",
    position: "CEO",
    company: "Matrix Technologies"
  },
  {
    id: "15",
    text: "The team at Soloop is incredibly professional and skilled. They delivered a solution that perfectly meets our needs.",
    author: "Amanda White",
    position: "Product Manager",
    company: "Innovation Hub"
  },
  {
    id: "16",
    text: "Soloop's commitment to excellence and their innovative solutions have been instrumental in our success.",
    author: "Kevin Johnson",
    position: "Director of Technology",
    company: "Future Forward"
  },
  {
    id: "17",
    text: "Outstanding technical expertise and professional service. Soloop delivered a solution that perfectly fits our business model.",
    author: "Nicole Davis",
    position: "VP of Operations",
    company: "Strategic Solutions"
  }
]; 